<template>
  <div>
    <!-- Modal -->
    <div
        class="modal show fade modal-secondary text-left"
        style="display: block;"
        v-if="show"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">

          <!-- Header -->
          <div class="modal-header">
            <h4 class="modal-title" style="text-transform:capitalize;">
              Details
            </h4>
            <button
                type="button"
                class="close"
                aria-label="Close"
                @click="handleClose"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <!-- Body -->
          <div class="modal-body">
            <div class="card">
              <div
                  class="card-body table-responsive p-0 table-striped table-hover table-bordered"
              >
                <table
                    class="table table-head-fixed table-hover-animation text-nowrap"
                >
                  <thead>
                  <tr>
                    <th>S.no</th>
                    <th>Status</th>
                    <th>Created By</th>
                    <th>Created At</th>
                    <th>Action</th>
                  </tr>
                  </thead>

                  <tbody>
                  <template v-for="(row, index) in list">
                    <!-- Main Row -->
                    <tr :key="'row-' + index">
                      <td>{{ index + 1 }}</td>

                      <td v-if="row.status == 0">
                        <span class="badge badge-light-info badge-glow badge-sm">
                          Generating
                        </span>
                      </td>

                      <td v-else-if="row.status == 2">
                        <span class="badge badge-light-danger badge-glow badge-sm">
                          Failed
                        </span>
                      </td>

                      <td v-else-if="row.status == 1">
                          <span class="badge badge-light-success badge-glow badge-sm">
                            Success
                          </span>
                      </td>

                      <td>
                        {{ row.user
                          ? row.user.first_name + ' ' + row.user.last_name
                          : 'Auto Generated' }}
                      </td>

                      <td>
                        {{
                          new Date(row.created_at)
                              .toISOString()
                              .slice(0, 16)
                              .replace('T', ' ')
                        }}
                      </td>

                      <td>
                        <button
                            class="btn btn-sm btn-primary"
                            @click="toggleDetails(index)"
                            :disabled="!row.settings"
                        >
                          {{ expandedIndex === index ? 'Hide Details' : 'View Details' }}
                        </button>
                      </td>
                    </tr>

                    <!-- Accordion Row -->
                    <tr
                        v-if="expandedIndex === index"
                        :key="'details-' + index"
                    >
<!--                      <td colspan="6" class="bg-light">-->
<!--                        <div class="json-wrapper">-->
<!--                          <vue-json-pretty-->
<!--                              :data="row.settings"-->
<!--                              :showDoubleQuotes="false"-->
<!--                          />-->
<!--                        </div>-->
<!--                      </td>-->
                      <td colspan="6" class="bg-light">
                        <div class="p-2">

                          <!-- Heading, the reportSentTo setting is displayed next to it when it is present -->
                          <h5 class="mb-2">
                            Reports sent to
                            <span
                                v-if="resolveReportSentTo(row.settings)"
                                class="badge badge-light-info badge-glow ml-1"
                            >
                              {{ resolveReportSentTo(row.settings) }}
                            </span>
                          </h5>

                          <div v-if="row.settings && row.settings.reportEmails && row.settings.reportEmails.length">
                            <span
                                v-for="(email, i) in row.settings.reportEmails"
                                :key="i"
                                class="badge badge-light-primary mr-1 mb-1 font-sm-1"
                            >
                              {{ email }}
                            </span>
                          </div>

                          <div v-else class="text-muted">
                            No email configured
                          </div>

                        </div>
                      </td>
                    </tr>
                  </template>

                  <tr v-if="list.length === 0">
                    <td colspan="6" class="text-center">
                      No data available
                    </td>
                  </tr>
                  </tbody>

                </table>
              </div>
            </div>
          </div>

          <!-- Footer -->
          <div class="modal-footer justify-content-between">
            <button
                type="button"
                class="btn btn-danger"
                @click="handleClose"
            >
              Close
            </button>
          </div>

        </div>
      </div>
    </div>

    <!-- Backdrop -->
    <div v-if="show" class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
import VueJsonPretty from 'vue-json-pretty'
import 'vue-json-pretty/lib/styles.css'

export default {
  components: {
    VueJsonPretty
  },
  props: ['show', 'data', 'index'],
  data() {
    return {
      list: [],
      loading: false,
      expandedIndex: null
    }
  },
  watch: {
    show(val) {
      this.list = []
      this.expandedIndex = null

      if (val) {
        // this.list = this.data?.filter(item => item.user != null) || []
        this.list = this.data || []
      }
    }
  },
  methods: {
    /* reads the reportSentTo setting, a plain value or a list, as a displayable string */
    resolveReportSentTo(settings) {
      if (!settings || typeof settings.reportSentTo == 'undefined' || settings.reportSentTo === null) {
        return ''
      }
      let value = settings.reportSentTo
      if (Array.isArray(value)) {
        return value.filter(item => item !== null && item !== '').join(', ')
      }
      return String(value)
    },
    toggleDetails(index) {
      this.expandedIndex =
          this.expandedIndex === index ? null : index
    },
    handleClose() {
      this.expandedIndex = null
      this.$emit('hide')
    }
  }
}
</script>

<style scoped>
.modal-dialog {
  overflow-y: initial !important;
}

.modal-body {
  height: 70vh;
  overflow-y: auto;
}

/* JSON scroll control */
.json-wrapper {
  max-height: 45vh;
  overflow-y: auto;
  padding: 10px;
}
</style>
